import {
  getCommonSectionInitActions,
  getCustomInitActionsForWidgets,
  getPageInfoInitActions,
} from './common';
import { getHomeWidgetConfigs } from '../../components/Sections/HomeSection/homeWidgetConfigs';

export function getHomeSectionInitActions(responseData) {
  const isMobile = responseData?.session?.device?.isMobile;
  // for desktop, this was originally 4 but init/home uses the default comment maxDepth
  // of 4 on the backend (because we can't send it in the api call), so we need
  // `maxDepth - 1` on the frontend in order to show the 'view more replies'
  const commentMaxDepth = isMobile ? 2 : 3;
  const params = { commentMaxDepth };

  return getCommonSectionInitActions(responseData, params, 'home').filter(
    action => action
  );
}

export const getCustomInitActionsForHomeWidgets = (
  responseData,
  requestParams
) => [
  ...getCustomInitActionsForWidgets(
    responseData,
    requestParams,
    getHomeWidgetConfigs({ t: () => null, dispatch: () => null })
  ),
  ...getPageInfoInitActions(responseData, requestParams),
];
